export default {
  image: 'A2_1.png',
  pdf: '220922_WA-HWF_001_A2_1_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-001',
    technicalValues: {
      soundReductionIndex: {
        output: '50,7',
        value: 50.7
      },
      heatTransferCoefficient: {
        output: '0,23',
        value: 0.23
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 1',
    construction: {
      composition: [
        {
          output: 'ohne',
          type: 'render',
          title: { de: 'Putz' },
          value: null
        },
        {
          output: '60 mm  Sto-Weichfaserplatte 039 VHF',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wvhf-60'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '≥ 60/100',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-100'
        },
        {
          output: '100 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-100'
        },
        {
          output: '12 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ia-12'
        },
        {
          output: '9,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'im-9'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '181,5',
        value: 181.5
      }
    }
  }
}
